import React from 'react';
import SvgIcon from './SvgIcon';
import { createStyles, makeStyles } from '@material-ui/core';

type Theme = 'regular' | 'cross' | 'light' | 'dark';

const useCloseStyles = makeStyles((theme) =>
    createStyles({
        border: {
            stroke: theme.palette.primary.main,
            fill: 'none'
        },
        cross: {
            fill: '#FFF'
        },
        lightCross: {
            fill: theme.palette.primary.main
        },
        lightBorder: {
            fill: '#000'
        },
        darkCross: {
            fill: theme.palette.grey[400]
        },
        darkBorder: {
            fill: '#FFF'
        }
    })
);

const useTheme = (theme?: Theme) => {
    const classes = useCloseStyles();
    if (theme === 'cross') {
        return {
            cross: classes.cross
            // border: classes.border
        };
    } else if (theme === 'light') {
        return {
            cross: classes.lightCross,
            border: classes.lightBorder
        };
    } else if (theme === 'dark') {
        return {
            cross: classes.darkCross,
            border: classes.darkBorder
        };
    } else {
        return {
            cross: classes.cross,
            border: classes.border
        };
    }
};

type Props = CommonIconProps & {
    theme?: Theme;
};

const CloseIcon = ({ theme, ...rest }: Props) => {
    const classes = useTheme(theme);
    return (
        <SvgIcon id="close-icon" {...rest}>
            <circle className={classes?.border} cx="12.04" cy="12.04" r="11.54" />
            <path
                className={classes?.cross}
                d="M16.19,7.89a.67.67,0,0,0-.93,0L12,11.11,8.82,7.89A.65.65,0,0,0,7.89,8a.64.64,0,0,0,0,.86L11.11,12,7.89,15.26a.65.65,0,0,0,.07.93.64.64,0,0,0,.86,0L12,13l3.22,3.22a.65.65,0,0,0,.93-.07.64.64,0,0,0,0-.86L13,12l3.22-3.22A.65.65,0,0,0,16.19,7.89Z"
                transform="translate(0 0)"
            />
        </SvgIcon>
    );
};

export default CloseIcon;
